/* eslint-disable import/prefer-default-export */

import env from '~/env';

export const BASE_URL = `${env.VITE_KEYCLOAK_API_URL}/realms/${env.VITE_KEYCLOAK_REALM}/protocol/openid-connect`;
